module.exports = __webpack_public_path__ + "static/media/hotcollectionone.82984836.png";